import React, { Component } from 'react'
import { Button, ButtonGroup } from '@blueprintjs/core';
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';

@inject('store', 'viewStore') @observer
class SupplierSearch extends Component {

  @action
  search() {
    let viewStore = this.props.viewStore;
    viewStore.supplierSearch.page = 1;
    this.props.viewStore.suppliers();
  }

  @action
  onSearchTermChange(e) {
    
    let {
      props: {
        viewStore: {
          supplierSearch
        }
      }
    } = this;
    this.props.viewStore.supplierSearch = {
      ...supplierSearch,
      term: e.target.value
    }
  }

  onEnter(event) {
    if (event.key === "Enter") {
      this.search()
    }
  }

  render() {
    let {
      props: {
        store,
        viewStore: {
          supplierSearch: { term }
        }
      }
    } = this;
    if(term == '*'){
      term = '';
    }
    return (
      <SearchFiltersToolbar
        searchButton={
          <SearchFiltersSearchButton onClick={this.search.bind(this)} />
        }
      >
        <input
          type="text"
          className="bp3-input input-control search-filters-toolbar__field-wide"
          placeholder="Supplier Name, Number, Email or Address"
          onChange={this.onSearchTermChange.bind(this)}
          defaultValue={term}
          onKeyPress={this.onEnter.bind(this)}
        />
      </SearchFiltersToolbar>
    )
  }
}

export default SupplierSearch;